import React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

export const ModelMessageTail: React.FC<SvgProps> = (props) => {
    return (
        <Svg width={15} height={19} viewBox="0 0 15 19" fill="none" {...props}>
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M333-46a5 5 0 015 5v57a5 5 0 01-5 5H20a5 5 0 01-4.932-4.174C13.118 18.216 10.914 19 8.58 19 5.368 19 2.401 17.514 0 15h.119c6.64 0 12.235-6.35 13.93-15H15v-41a5 5 0 015-5z"
                fill="#DAF4FF"
            />
        </Svg>
    );
};

export default React.memo(ModelMessageTail);
